import { observer } from 'mobx-react-lite';

import { Slider } from '@/components/ui/Slider';

import { IMPORTANCE_MAX } from '../card-importance';
import { useMinCardImportance } from '../use-min-card-importance';

/** The slider for the minimum card importance. At 0, every card shows. */
export const ImportanceThresholdSlider = observer(
  ({ className }: { className?: string }) => {
    const { minImportance, setMinImportance } = useMinCardImportance();
    return (
      <Slider
        aria-label="Minimum card importance"
        className={className}
        value={[minImportance]}
        min={0}
        max={IMPORTANCE_MAX}
        step={1}
        onValueChange={([value]) => setMinImportance(value)}
      />
    );
  }
);
